import Vue from 'vue'
const vm = new Vue()

const api = {}
/**
 * 查询法人信息
 *
 */
api.listLegalByEnterpriseId =  function(id) {
    let url = `/kj-kyc/enterprise/listLegalByEnterpriseId?enterpriseId=${id}&containsManager=true`
    return vm.$http.get(url)
}

export default api